import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { initGTM } from "@/lib/gtm";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import Stats from "@/components/Stats";
import Usps from "@/components/Usps";
import Services from "@/components/Services";
import Owners from "@/components/Owners";
import References from "@/components/References";
import Jobs from "@/components/Jobs";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";

const Home = () => (
  <div data-testid="home-page">
    <Header />
    <main>
      <Hero />
      <Stats />
      <Usps />
      <Services />
      <Owners />
      <References />
      <Jobs />
      <Contact />
    </main>
    <Footer />
  </div>
);

function App() {
  useEffect(() => {
    initGTM();
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminDashboard />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
